import React, { FC } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { Checkbox, PhaseOptionContainer } from './PhaseOption.style';

interface IProps {
  activeFrame: any;
  cardiacPhase: any;
  dicom: any;
  phaseLabel: any;
  setPhaseLabel: any;
}

const PhaseOption: FC<IProps> = props => {
  const { activeFrame, cardiacPhase, dicom, phaseLabel, setPhaseLabel } = props;
  const isSelected = ![null, undefined].includes(phaseLabel?.frame);
  const hotkey = cardiacPhase?.value?.[0];
  const label = cardiacPhase?.value;

  const handlePhaseOptionOnClick = () => {
    const newPhase =
      phaseLabel?.phaseClass === cardiacPhase?.value && phaseLabel?.frame === activeFrame?.uuid
        ? null
        : cardiacPhase?.value;

    setPhaseLabel({
      ...phaseLabel,
      frame: activeFrame?.uuid,
      frameIndex: activeFrame?.index,
      phaseClass: newPhase,
      dicom: dicom?.uuid,
    });
  };

  useHotkeys(hotkey, event => {
    event?.preventDefault();
    handlePhaseOptionOnClick();
  });

  return (
    <PhaseOptionContainer $isSelected={isSelected} onClick={handlePhaseOptionOnClick}>
      <Checkbox checked={isSelected} readOnly />({hotkey}) {label}
    </PhaseOptionContainer>
  );
};

export default PhaseOption;
